
class MessageFactory {
  activityId;
  content;
  media;
  direction;
  dateTime;
  error;
  uploadingFile;
  pendingUpload;

  constructor({
    content,
    media,
    activityId,
    direction,
    dateTime,
    error,
    uploadingFile,
    pendingUpload
    }) {
    this.content = content;
    this.media = media;
    this.activityId = activityId;
    this.direction = direction;
    this.dateTime = dateTime;
    this.error = error;
    this.uploadingFile = uploadingFile;
    this.pendingUpload = pendingUpload;
  }
}

export default MessageFactory;



// WEBPACK FOOTER //
// ./chat-app/services/messageFactory.js